import { useEffect, useState } from "react";

const useBrand = () => {
  const [brand, setBrand] = useState('');

  useEffect(() => {
    const brandDiv = document.getElementById('site-brand-setting');
    setBrand(brandDiv?.dataset?.brand || 'fender');
  }, []);

  return brand;
}

export default useBrand;